import React from "react";

function RulesItem(props:any) {
    return (
        <div className="rules-item">
            <div className="rules-item_header">
                <span className="rules-item_header__title">
                    {props.title}
                </span>
                <img src={props.icon} alt="icon"/>
            </div>
            <div className="rules-item_content">
                {props.content_1?<>{props.index + 1}.1. {props.content_1}</>: ""}<br/>
                {props.content_2?<>{props.index + 1}.2. {props.content_2}</>: ""}<br/>
                {props.content_3?<>{props.index + 1}.3. {props.content_3}</>: ""}<br/>
            </div>

        </div>
    )
}

export default RulesItem